/**
 * Definitions of all publicly available event names
 * All public event names
 * names should be like 'namespace.modelName.whatHappened'
 *
 */
// eslint-disable-next-line no-shadow
export enum IPublicEnumEventNames {
}